<template>
    <div>
        <div class="row" v-show="loadingState">
            <div class="col text-center">
                <img src="../assets/loading.gif" alt="">
            </div>
        </div>

        <div class="row" style="height: 100vh" v-show="loadingState === false">
            <div class="col">
                <iframe id="iframe" src="https://www6.doramasmp4.com/" frameborder="0" width="100%" height="100%"
                        scrolling="auto"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Doramas",
        data() {
            return {
                loadingState: true,
            }
        },
        mounted() {
            document.getElementById('iframe').onload = () => {
                this.loadingState = false;
            }
        },
    }
</script>

<style scoped>

</style>
